import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useDispatch } from 'react-redux'
import { DeleteReceivingItemAction } from '../../redux/actions/receiving/action'
import { useReceivedItemDataGridContext } from './ReceivedDetailsItemDataGrid'

const DeleteDialog = ({open=false, handleClose, items}) => {
    const {receivingId, closeDetail} = useReceivedItemDataGridContext()
    const actionDispatch = useDispatch()
    const [lastChance, setLastChance]= React.useState(false)

    const handleDelete=()=>{
        actionDispatch(DeleteReceivingItemAction({
            receivingId : receivingId,
            Receivings : items,
            callback : ()=>{
                handleClose()
                closeDetail()
            }
        }))
    }

    const openLastChance=()=>{
        setLastChance(true)
    }

    return (
        <>
        { lastChance ?
        <LastChanceDialog open={lastChance} action={handleDelete} handleClose={handleClose} />
        :
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Suppression</DialogTitle>
            <DialogContent>
                <Alert severity="error">
                    {"Vous êtes sur le points de supprimer un ou plusieurs produits de reception"}
                </Alert>
            </DialogContent>
            <DialogActions>
                <Grid container justify='space-between'>
                    <Button onClick={handleClose} color="primary" variant="contained">ANNULER</Button>
                    <Button onClick={openLastChance} color="secondary" variant="contained">SUPPRIMER</Button>
                </Grid>
            </DialogActions>
        </Dialog>
        }
        </>
    )
}

export default DeleteDialog



const LastChanceDialog=({open=false, action, handleClose})=>{


    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Dernière chance</DialogTitle>
            <DialogContent>
                <Alert severity="error">
                    {"Dernière chance cet action est irréversible"}
                </Alert>
            </DialogContent>
            <DialogActions>
                <Grid container justify='space-between'>
                    <Button onClick={handleClose} color="primary" variant="contained">ANNULER</Button>
                    <Button onClick={action} color="secondary" variant="contained">CONTINUER</Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}